export const CallsColumns = [
    {
        name: 'Курьер',
        key: 'courierName',
    },
    {
        name: 'Накладная/Заказ',
        key: 'invoiceId',
    },
    {
        name: 'Действие',
        key: 'type',
    },
    {
        name: 'Кому звонили',
        key: 'phone',
    },
    {
        name: 'Время звонка',
        key: 'createdAt',
    },
    {
        name: 'Город',
        key: 'cityName',
    },
    {
        name: 'Клиент',
        key: 'clientName',
    },
]
